import { createSelector } from 'reselect';

import { IAddedAddressesIds, IOrgAddress, TInvalidOrgAddress } from '../../types/addressBook';
import { IAppState } from '../reducers';

export const selectRootState = (state: IAppState) => state.addressBook;

export const selectIsAddressBookLoading = createSelector(selectRootState, (orgAddresses) => orgAddresses.isLoading);

export const selectAddressBook = createSelector(selectRootState, (orgAddresses): IOrgAddress[] | undefined | null =>
  orgAddresses && orgAddresses.items ? orgAddresses.items : undefined,
);

export const selectInvalidAddresses = createSelector(
  selectRootState,
  (orgAddresses): TInvalidOrgAddress[] | undefined | null =>
    orgAddresses && orgAddresses.invalidAddresses ? orgAddresses.invalidAddresses : undefined,
);

export const selectAddressBookError = createSelector(selectRootState, (orgAddresses) => orgAddresses.error);

export const selectOrgAddressById = (id?: string) =>
  createSelector(selectAddressBook, (addresses) =>
    id && addresses && addresses.length ? addresses.find((address) => address.uid === id) : undefined,
  );

export const selectAddedAddressesIds = createSelector(
  selectRootState,
  (orgAddresses): IAddedAddressesIds | null => orgAddresses.addedAddressesIds,
);
